export const textColorOptions = [
    'default',
    'content-default',
    'default-disabled',
    'subtle',
    'xsubtle',
    'brand-01',
    'brand-02',
    'brand-02-strong',
    'brand-03',
    'brand-04',
    'content-knockout',
    'knockout',
    'validation',
    'notification',
    'warning',
    'error',
    'success',
    'info', 
]